import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
} from "@material-ui/core";
import { Warning as WarningIcon } from "@material-ui/icons";
import moment from "moment";
import { ACHIEVEMENT } from "../../../constants/selectOptions";

function DuplicateCheckModal({ open, handleClose, duplicateList, handleSelect }) {
  const getAwardTypeLabel = (value) => {
    const found = ACHIEVEMENT.awardType.find((e) => e.value === value);
    return found ? found.title : value || "-";
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center">
          <WarningIcon style={{ color: "#ff9800", marginRight: 8 }} />
          <Typography variant="h6">Phát hiện giải thưởng trùng lặp</Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" style={{ marginBottom: 16 }}>
          Hệ thống phát hiện các giải thưởng có tên đề tài tương tự. Vui lòng kiểm tra và chọn chỉnh sửa nếu đây là giải
          thưởng đã tồn tại.
        </Typography>
        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>
                  <b>Tên đề tài, công trình được trao giải</b>
                </TableCell>
                <TableCell>
                  <b>Loại giải thưởng</b>
                </TableCell>
                <TableCell>
                  <b>Cơ quan tổ chức</b>
                </TableCell>
                <TableCell>
                  <b>Thao tác</b>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {duplicateList.map((item, index) => (
                <TableRow key={index}>
                  <TableCell>{item.achievement?.awardedProjectName || "-"}</TableCell>
                  <TableCell>{getAwardTypeLabel(item.achievement?.awardType)}</TableCell>
                  <TableCell>{item.achievement?.organizingAgency || "-"}</TableCell>
                  <TableCell>
                    <Button
                      size="small"
                      variant="contained"
                      color="primary"
                      onClick={() => handleSelect(item.achievement)}
                    >
                      Chỉnh sửa
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="default">
          Đóng
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DuplicateCheckModal;

